import classNames from 'classnames'
import getLinkToDetail from 'helpers/getLinkToDetail'
import getTitle from 'helpers/getTitle'
import useTranslate from 'modules/local/useTranslate'
import React from 'react'
import {Link} from 'react-router-dom'
import {renderIf} from 'views/Shared'
import {HeaderWithIconLine} from "../../Templates/items/ListHeader";
import {BsInfoCircleFill} from "react-icons/bs";
import {GoDotFill} from "react-icons/go";
import {ItemInformation} from "../../../../components/common/ItemInformation";

const CourseClassInformation = ({ item, style, className, showDescription = true }) => {
    const t = useTranslate()
    const {
        title,
        course,
        coordinators = [],
        number_of_students,
    } = item ?? {}

    return (
        <div style={style} className={classNames('space-y-1', className)}>
            <div className="p-3 flex flex-col border border-color-50 background shadow-md rounded-2xl">
                <div className="flex flex-col">
                    <span className="font-semibold text-gray-500 tracking-wider">
                        {t('classes')}
                    </span>
                    <span className="font-bold text-lg text-color-000 tracking-wide">
                        {title}
                    </span>
                </div>
                <div className="mt-2 pt-2 border-t border-color-50 flex flex-col gap-1">
                    <span className="space-x-1 text-xs tracking-wide">
                        <span className="text-color-400 whitespace-no-wrap">{`${t('belong to')} : `}</span>
                        <Link
                            to={getLinkToDetail(course)}
                            className="font-semibold text-color-100 no-underline">
                            {getTitle(course)}
                        </Link>
                    </span>
                    <span className="space-x-1 text-xs tracking-wide">
                        <span className="text-color-400 whitespace-no-wrap">{`${t('class size')} : `}</span>
                        <span className="font-semibold text-color-100 no-underline">
                            {`${number_of_students} ${t('students')}`}
                        </span>
                    </span>
                    {renderIf(
                        coordinators?.length,
                        <div className="space-x-1 text-xs tracking-wide">
                            <span className="text-color-400 whitespace-no-wrap">{`${t('coordinators')} : `}</span>
                            {coordinators.map((e, i) => {
                                const {teacher} = e ?? {}
                                return (
                                    <span key={i} className="font-semibold text-color-100">
                                        {`${teacher?.prefix_title || ""} ${teacher?.fullname}`} {i < coordinators?.length - 1 && ', '}
                                    </span>
                                )
                            })}
                        </div>
                    )}
                </div>

            </div>
        </div>
    )
}

export default CourseClassInformation
